import * as React from "react";
import { Map, Clock, Star, Camera, MapPin, CircleCheck, ArrowRight, Route } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
const features = [{
  icon: Route,
  text: "Advertising"
}, {
  icon: Clock,
  text: "Email Marketing"
}, {
  icon: Star,
  text: "AI Development"
}, {
  icon: Map,
  text: "Branding"
}, {
  icon: Camera,
  text: "Software Development"
}, {
  icon: MapPin,
  text: "Conversions"
}];
const tourPackages = [{
  id: "full-stack-web",
  title: "ADVERTISING\xA0",
  description: "Performance-driven advertising campaigns designed to maximize reach, engagement, and measurable growth.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/full_stack_development.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/full_stack_development.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/full_stack_development.png-wvc-sizes",
    alt: "Full-Stack Engineering"
  },
  duration: "8 - 16 Weeks",
  highlights: ["Website Developing", "Google Ads", "TikTok Ads", "Email Marketing"],
  link: "/TheForgePage"
}, {
  id: "mobile-solutions",
  title: "SOFTWARE\xA0",
  description: "End-to-end software development solutions built for scalability, performance, and seamless user experiences across every platform and device.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/mobile_app_solutions.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/mobile_app_solutions.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/mobile_app_solutions.png-wvc-sizes",
    alt: "Mobile App Forge"
  },
  duration: "10 - 20 Weeks",
  highlights: ["React Native / Flutter", "Mobile App Development", "Offline-First Sync", "App Store Optimization"],
  link: "/TheForgePage"
}, {
  id: "cloud-integration",
  title: "HIGHLIGHTS",
  description: "Modernize your infrastructure with scalable cloud solutions designed for high availability and cost efficiency.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/cloud_infrastructure.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/cloud_infrastructure.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/cloud_infrastructure.png-wvc-sizes",
    alt: "Cloud and DevOps Integration"
  },
  duration: "4 - 12 Weeks",
  highlights: ["AWS / Azure / GCP", "Kubernetes Orchestration", "AI Integration", "Security Hardening"],
  link: "/TheForgePage"
}];
export default function OurChauffeurTourPackages() {
  return <section data-section-id="244745" id="technical-specializations" className="bg-background text-foreground ![padding:100px_0px_96px_0px]">
      <div className="container mx-auto px-4 md:px-6">
        
        {}
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-16">
          <Badge variant="outline" className="mb-4 border-primary/50 text-primary px-4 py-1 text-sm uppercase tracking-widest font-mono">
            Core Competencies
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default mb-6 tracking-tight">
            Technical <span className="text-primary">Specializations</span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl mb-10 font-default">
            We blend agile methodology with cutting-edge technologies to accelerate your product's time-to-market. Our engineering team focuses on translating complex requirements into elegant software.
          </p>

          {}
          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {features.map((feature, i) => {
            const Icon = feature.icon;
            return <Badge key={i} data-index={i} variant="secondary" className="bg-secondary/20 hover:bg-secondary/40 text-foreground border border-border/40 py-2 px-4 text-xs font-mono flex items-center gap-2 transition-colors rounded-md">
                  <Icon className="w-4 h-4 text-primary" />
                  {feature.text}
                </Badge>;
          })}
          </div>
        </div>

        {}
        

        {}
        <div className="mt-16 text-center">
          <p className="text-muted-foreground mb-6 font-default">
            Need a custom solution tailored to your specific business logic?
          </p>
          <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-md font-mono uppercase tracking-wider">
            <Link to="/StartAProjectPage">
              Request Custom Architecture
            </Link>
          </Button>
        </div>

      </div>
    </section>;
}